export function getToggleLanguage(lang) {
  if (lang === 'th') {
    return 'TH';
  } else {
    return 'EN';
  }
}

export const loglist = {
  LOGIN_PRUID_HOME: 'Log in - Click next PRU ID home (Step2)',
  'REGISTER_ACCEPT_TERMANDCONDITION(CWP)':
    'Register - Click Accept on Term and condition(CWP)',
  'REGISTER_CANCEL_TERMANDCONDITION_CHANGE(CWP)':
    'Register - Click Cancel on Term and condition change(CWP)',
  'REGISTER_ACCEPT_TERMANDCONDITION_CHANGE(CWP)':
    'Register - Click Accept on Term and condition change(CWP)',
  'REGISTER_MOBILE_SELECTION(CWP)': 'Register - Mobile Selection(CWP)',
  'REGISTER_RECEIVED_OTP(CWP)': 'Register - Click Not received OTP(CWP)',
  'REGISTER_CONFIRM_OTP(CWP)': 'Register - Click Confirm OTP(CWP)',
  'REGISTER_REFRESH_CAPTCHA(CWP)': 'Register - Refresh Capcha(CWP)',
  'REGISTER_REFRESH_OTP_MORE_5_TIME(CWP)':
    'Register - Refresh Capcha (Receive OTP more than 5 times)(CWP)',
  'REGISTER_RESEND_OTP_MORE_5_TIME(CWP)':
    'Register - Click Resend OTP (Receive OTP more than 5 times)(CWP)',
  'REGISTER_EMAIL(CWP)': 'Register - Email success(CWP)',
  'REGISTER_ACCEPT_TERMANDCONDITION(PRUid)':
    'Register - Click Accept on Term and condition(PRUid)',
  'REGISTER_CANCEL_TERMANDCONDITION_CHANGE(PRUid)':
    'Register - Click Cancel on Term and condition change(PRUid)',
  'REGISTER_ACCEPT_TERMANDCONDITION_CHANGE(PRUid)':
    'Register - Click Accept on Term and condition change(PRUid)',
  'REGISTER_MOBILE_SELECTION(PRUid)': 'Register - Mobile Selection(PRUid)',
  'REGISTER_RECEIVED_OTP(PRUid)': 'Register - Click Not received OTP(PRUid)',
  'REGISTER_CONFIRM_OTP(PRUid)': 'Register - Click Confirm OTP(PRUid)',
  'REGISTER_REFRESH_CAPTCHA(PRUid)': 'Register - Refresh Capcha(PRUid)',
  'REGISTER_REFRESH_OTP_MORE_5_TIME(PRUid)':
    'Register - Refresh Capcha (Receive OTP more than 5 times)(PRUid)',
  'REGISTER_RESEND_OTP_MORE_5_TIME(PRUid)':
    'Register - Click Resend OTP (Receive OTP more than 5 times)(PRUid)',
  'REGISTER_EMAIL(PRUid)': 'Register - Email success(PRUid)',
  LOGIN_RECEIVED_OTP: 'OTP - Click Not received OTP',
  LOGIN_CONFIRM_OTP: 'OTP - Click Confirm',
  LOGIN_RECEIVED_OTP_VIA_EMAIL: 'OTP - Click Receive OTP via E-mail',
  LOGIN_REFRESH_CAPTCHA: 'OTP - Refresh Capcha',
  LOGIN_REFRESH_OTP_MORE_5_TIME:
    'OTP - Refresh Capcha (Receive OTP more than 5 times)',
  LOGIN_RESEND_OTP_MORE_5_TIME:
    'OTP - Click Resend OTP (Receive OTP more than 5 times)',
  LOGIN_SUCCESS: 'Success - Back to PRUpolicy (System name)',
};

export function getValueCWPuser(status) {
  if (status === 'old') {
    return '(CWP)';
  } else if (status === 'new') {
    return '(PRUid)';
  } else {
    return '';
  }
}

export function getValueUserMode(mode) {
  if (mode === 'L') {
    return 'LOGIN_';
  } else {
    return 'REGISTER_';
  }
}

export function getCommand(mode, command, status) {
  let newCommand = getValueUserMode(mode) + command + getValueCWPuser(status);

  return newCommand;
}
